import React from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import { MD3Theme, useTheme } from "react-native-paper";
import { Text } from "../utils/fontsLoader";
import PropTypes from "prop-types";

const RadioButton = ({ options, value, onChange, editable = true, sizeFactor = 1 }) => {
  const theme = useTheme();
  const styles = stylesGen(theme, sizeFactor);

  return (
    <View style={styles.container}>
      {options.map((option) => (
        <TouchableOpacity
          key={option.value}
          style={styles.button}
          onPress={() => editable && onChange(option.value)}
          disabled={!editable}
        >
          <View style={[
            styles.outerCircle,
            value === option.value && styles.selectedOuterCircle,
          ]}>
            {value === option.value && <View style={styles.innerCircle} />}
          </View>
          <Text style={styles.text} numberOfLines={0}>
            {option.label}
          </Text>
        </TouchableOpacity>
      ))}
    </View>
  );
};

const stylesGen = (theme: MD3Theme, sizeFactor: number) => StyleSheet.create({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "flex-start",
    justifyContent: "center",
    gap: 15,
    width: "100%",
  },
  button: {
    flexDirection: "row",
    alignItems: "center",
    gap: 7,
    minWidth: 0,
    flexShrink: 1,
  },
  outerCircle: {
    height: 20 * sizeFactor,
    width: 20 * sizeFactor,
    borderRadius: 10 * sizeFactor,
    borderWidth: 1,
    borderColor: theme.colors.onBackground,
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  selectedOuterCircle: {
    borderColor: theme.colors.primary,
  },
  innerCircle: {
    height: 12 * sizeFactor,
    width: 12 * sizeFactor,
    borderRadius: 6 * sizeFactor,
    backgroundColor: theme.colors.primary,
  },
  text: {
    fontSize: 18 * sizeFactor,
    marginBottom: 3,
    flexWrap: 'wrap',
    flexShrink: 1,
    maxWidth: '100%',
  },
});

RadioButton.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    label: PropTypes.any.isRequired,
  })).isRequired,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  editable: PropTypes.bool,
  sizeFactor: PropTypes.number,
};

export default RadioButton;